import { render, staticRenderFns } from "./UserSettingsChangePin.vue?vue&type=template&id=556e1589"
import script from "./UserSettingsChangePin.vue?vue&type=script&lang=js"
export * from "./UserSettingsChangePin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports